import { Controller } from "@hotwired/stimulus";
import { AdjustHeight } from "../shared/adjust_height";

// Connects to data-controller="resumin--resize-textarea"
export default class extends Controller {
  connect() {
    AdjustHeight(this);
    this._adjustElementHeight(this.element);
  }

  adjustHeight(e) {
    e.preventDefault();
    this._adjustElementHeight(e.currentTarget);
  }

  _adjustElementHeight(element) {
    this.adjustElementHeight(element);
  }
}
